(function($, d, g) {
    /* jshint validthis: true */
	"use strict";

    function init() {
        $("#all-newsletter-lists input[type='checkbox']").on("change", getSelectedCheckboxLists);
    }

    function getSelectedCheckboxLists() {
        var selectedValues = [];
        $("input[type='checkbox']:checked").each(function () {
            if($(this).val() != 'on')
                selectedValues.push($(this).val());
        });

        $('#emRegisteredLists input[name="listId"]').val(selectedValues.join(','));
    }

    $(g).ready(init);

})(jQuery, document, window);